import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "../node_modules/bootstrap/dist/js/bootstrap";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import { SavedEventsProvider } from "./context/SavedEventContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SavedEventsProvider>
      <ToastContainer />

      <App />
    </SavedEventsProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
